import { render, staticRenderFns } from "./QSubSeccion.vue?vue&type=template&id=96d99950"
import script from "./QSubSeccion.vue?vue&type=script&lang=js"
export * from "./QSubSeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports